import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ExclusiveSection() {
  const exclusive = works.filter((w) => w.isExclusive);

  return (
    <section className="bg-background-100 py-12 md:py-16" aria-label="独家抢先看">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="独家抢先看"
          title="只在叮咚 · 全网抢先一步"
          desc="与作者和版权方深度合作，为你争取首发抢先看的独家权益，更新进度领先全网。"
        />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {exclusive.slice(0, 3).map((work, idx) => (
            <Link
              key={work.id}
              to={`/work/${work.id}`}
              className={`group relative flex flex-col overflow-hidden rounded-xl bg-background-50 border border-background-200 transition-transform duration-300 hover:-translate-y-1 ${
                idx === 0 ? "md:row-span-2 lg:row-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? "aspect-[16/10]" : "aspect-[16/7]"}`}>
                <img
                  src={work.cover}
                  alt={`${work.title} 独家首发作品`}
                  title={`${work.title} 独家抢先看`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  <i className="ri-vip-crown-2-fill mr-1" />独家首发
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-between p-4 md:p-5">
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 md:text-xl">{work.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600 md:text-sm">{work.author} · {work.category}</p>
                  <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{work.description}</p>
                </div>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500 md:text-sm">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-secondary-500" />
                    <b className="text-foreground-800">{work.rating}</b> 分 · {work.chapters}话
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary-600 group-hover:gap-2 transition-all">
                    立即抢先看 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}